import React from 'react';
import { PayPalPaymentAccelerator } from '@vp/payment-components';
import { getAuthHeaderAndShopperId } from '@vp/common-api-utils/authHelpers';
import { Button } from '@vp/swan';
import useSiteData from '../../hooks/useSiteData';
import useTracking from '../../hooks/useTracking';

export const PayPalPaymentAcceleratorWrapper = ({
  hideButton,
  disableButton,
}: {
  hideButton: boolean;
  disableButton: boolean;
}) => {
  const { uiLocalization, vistacartTenant, paymentEnvironment, siteName } =
    useSiteData();
  const { trackPayPalPaymentAcceleratorClicked } = useTracking();
  const { authHeader, shopperId } = getAuthHeaderAndShopperId();
  const siteLocale = uiLocalization && uiLocalization.locale;

  if (hideButton) {
    return null;
  }

  return (
    <>
      {/* An empty disabled Button component to simulate a disabled experience for PayPal button */}
      {disableButton && (
        <Button disabled component="a" width="full-width" aria-disabled />
      )}
      {/* Hide PayPal button instead of unmounting it to make the transition smoother  */}
      <div
        style={{
          zIndex: 0,
          position: 'inherit',
          display: disableButton ? 'none' : 'block',
        }}
      >
        <PayPalPaymentAccelerator
          authHeader={authHeader}
          environment={paymentEnvironment}
          locale={siteLocale}
          shopperId={shopperId}
          tenant={vistacartTenant}
          site={siteName}
          trackingOnClickHandler={trackPayPalPaymentAcceleratorClicked}
        />
      </div>
    </>
  );
};
